import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_URL } from './../common';

const BASE_URL = `${API_URL}/api/ICD10/`;
const BASE_URL_ICD9 = `${API_URL}/api/ICD9/`;

@Injectable({
    providedIn: 'root',
})
export class SearchService {
    private apiUrl = 'https://api.ipify.org?format=json';
    public client_ip: string;
    constructor(private httpClient: HttpClient) {
        this.getIpAddress().subscribe(
            (data: any) => {
                this.client_ip = data.ip;
            },
            (error) => {
                console.log('Error:', error);
            }
        );
    }
    getIpAddress(): Observable<any> {
        return this.httpClient.get<any>(this.apiUrl);
    }

    search(q: any | undefined, lang: string, vol1: boolean, vol3: boolean) {
        if (!q || q === '*') {
            q = '';
        } else {
            q = q.toLowerCase();
        }
        const headers = new HttpHeaders({});
        if (this.client_ip) {
            headers.append('X-Client-IP', this.client_ip);
        }
        return this.httpClient.get<any>(`${BASE_URL}search/${q}?lang=${lang}&vol1=${vol1 ? 1 : 0}&vol3=${vol3 ? 1 : 0}&html=true`, {
            headers: headers,
        });
    }

    getListTreeOfSearch(model: string, id: number, lang: string) {
        return this.httpClient.get<any>(`${BASE_URL}tree/${model}?id=${id}&lang=${lang}`);
    }

    search_ICD9(q: any | undefined, lang: string) {
        const headers = new HttpHeaders({});
        if (this.client_ip) {
            headers.append('X-Client-IP', this.client_ip);
        }
        if (!q || q === '*') {
            q = '';
        } else {
            q = q.toLowerCase();
        }
        return this.httpClient.get<any>(`${BASE_URL_ICD9}search/${q}?lang=${lang}&html=true`, {
            headers: headers,
        });
    }

    getListTreeOfSearch_ICD9(model: string, id: number, lang: string) {
        return this.httpClient.get<any>(`${BASE_URL_ICD9}tree/${model}?id=${id}&lang=${lang}`);
    }
}
